import { Route } from "@angular/router";
import { initialDataResolver } from "./app.resolvers";
import { AuthGuard } from "./core/auth/guards/auth.guard";
import { NoAuthGuard } from "./core/auth/guards/noAuth.guard";
import { RoutePermissionGuard } from "./core/auth/guards/route-permission.guard";
import { LayoutComponent } from "./layout/layout.component";
import { environment } from "../environments/environment";
import { devRoutes } from "./app.dev-routes";
import { BusinessPartnerAddressPendingSyncComponent } from "./modules/components/business-partners/business-partner-address-pending-sync/business-partner-address-pending-sync.component";
import { BusinessPartnerContactComponent } from "./modules/components/business-partners/business-partner-contact/business-partner-contact.component";
import { BusinessPartnerFunctionComponent } from "./modules/components/business-partners/business-partner-function/business-partner-function.component";
import { BusinessPartnerGroupComponent } from "./modules/components/business-partners/business-partner-group/business-partner-group.component";
import { BusinessPartnerNewsComponent } from "./modules/components/business-partners/business-partner-news/business-partner-news.component";
import { BusinessPartnerSubGroupComponent } from "./modules/components/business-partners/business-partner-sub-group/business-partner-sub-group.component";
import { BusinessPartnerTypeComponent } from "./modules/components/business-partners/business-partner-type/business-partner-type.component";
import { BusinessPartnerComponent } from "./modules/components/business-partners/business-partner/business-partner.component";
import { PaymentManagementComponent } from "./modules/components/collections/payment-management/payment-management.component";
import { AddressTypeComponent } from "./modules/components/common/address-type/address-type.component";
import { PhoneTypeComponent } from "./modules/components/common/phone-type/phone-type.component";
import { SocialMediaTypeComponent } from "./modules/components/common/social-media-type/social-media-type.component";
import { ChannelComponent } from "./modules/components/configuration/channel/channel.component";
import { CompanyComponent } from "./modules/components/configuration/company/company.component";
import { DistributionChainComponent } from "./modules/components/configuration/distribution-chain/distribution-chain.component";
import { DivisionComponent } from "./modules/components/configuration/division/division.component";
import { OfficeGroupComponent } from "./modules/components/configuration/office-group/office-group.component";
import { PlantComponent } from "./modules/components/configuration/plant/plant.component";
import { SalesOfficeComponent } from "./modules/components/configuration/sales-office/sales-office.component";
import { SalesOrganizationComponent } from "./modules/components/configuration/sales-organization/sales-organization.component";
import { TenantComponent } from "./modules/components/configuration/tenant/tenant.component";
import { WarehouseComponent } from "./modules/components/configuration/warehouse/warehouse.component";
import { DocumentClassComponent } from "./modules/components/document/document-class/document-class.component";
import { DocumentRangeComponent } from "./modules/components/document/document-range/document-range.component";
import { DocumentTypeComponent } from "./modules/components/document/document-type/document-type.component";
import { EmissionPointComponent } from "./modules/components/document/emission-point/emission-point.component";
import { HomeComponent } from "./modules/components/home/home.component";
import { LocationFiveComponent } from "./modules/components/locations/location-five/location-five.component";
import { LocationFourComponent } from "./modules/components/locations/location-four/location-four.component";
import { LocationOneComponent } from "./modules/components/locations/location-one/location-one.component";
import { LocationSixComponent } from "./modules/components/locations/location-six/location-six.component";
import { LocationThreeComponent } from "./modules/components/locations/location-three/location-three.component";
import { LocationTwoComponent } from "./modules/components/locations/location-two/location-two.component";
import { BadConditionMotiveComponent } from "./modules/components/master/bad-condition-motive/bad-condition-motive.component";
import { ExpeditionConditionComponent } from "./modules/components/master/expedition-condition/expedition-condition.component";
import { PaymentConditionComponent } from "./modules/components/master/payment-condition/payment-condition.component";
import { PriceListComponent } from "./modules/components/master/price-list/price-list.component";
import { ReasonForRejectionComponent } from "./modules/components/master/reason-for-rejection/reason-for-rejection.component";
import { ReasonForVisitComponent } from "./modules/components/master/reason-for-visit/reason-for-visit.component";
import { ReasonForBlockComponent } from "./modules/components/master/reasons-for-block/reasons-for-block.component";
import { RequirementComponent } from "./modules/components/master/requirement/requirement.component";
import { StrategyListComponent } from "./modules/components/master/strategy-list/strategy-list.component";
import { UnitOfMeasurementComponent } from "./modules/components/master/unit-of-measurement/unit-of-measurement.component";
import { MaterialBrandComponent } from "./modules/components/material/material-brand/material-brand.component";
import { MaterialGroupComponent } from "./modules/components/material/material-group/material-group.component";
import { MaterialComponent } from "./modules/components/material/material/material.component";
import { OpenPItemComponent } from "./modules/components/open-p-item/open-p-item.component";
import { BankComponent } from "./modules/components/payment-master/bank/bank.component";
import { PaymentMethodComponent } from "./modules/components/payment-master/payment-method/payment-method.component";
import { PaymentTypeComponent } from "./modules/components/payment-master/payment-type/payment-type.component";
import { CensusQualityComponent } from "./modules/components/reports/census-quality/census-quality.component";
import { RequestChangeComponent } from "./modules/components/reports/exchange/request-change/request-change.component";
import { AttentionStockComponent } from "./modules/components/reports/historic/attention-stock/attention-stock.component";
import { ChangeProductComponent } from "./modules/components/reports/historic/change-product/change-product.component";
import { OpenItemComponent } from "./modules/components/reports/historic/open-item/open-item.component";
import { OrderCustomerComponent } from "./modules/components/reports/historic/order-customer/order-customer.component";
import { OrderPaymentComponent } from "./modules/components/reports/historic/order-payment/order-payment.component";
import { ProrationComponent } from "./modules/components/reports/historic/proration/proration.component";
import { LostSaleV2Component } from "./modules/components/reports/lost-sale-v2/lost-sale-v2.component";
import { LostSaleCommercialComponent } from "./modules/components/reports/lost-sale-v2/tabs/commercial/lost-sale-commercial.component";
import { LostSaleSummaryComponent } from "./modules/components/reports/lost-sale-v2/tabs/summary/lost-sale-summary.component";
import { LostSaleComponent } from "./modules/components/reports/lost-sale/lost-sale.component";
import { StockBreakComponent } from "./modules/components/reports/stock-break/stock-break.component";
import { VisitControlComponent } from "./modules/components/reports/visits/visit-control/visit-control.component";
import { VisitReportComponent } from "./modules/components/reports/visits/visit-report/visit-report.component";
import { RouteAreaComponent } from "./modules/components/routing/route-area/route-area.component";
import { RouteGroupComponent } from "./modules/components/routing/route-group/route-group.component";
import { RouteComponent } from "./modules/components/routing/route/routes.component";
import { SubRouteActivityComponent } from "./modules/components/routing/sub-route-activitie/sub-route-activitie.component";
import { SubRouteFunctionComponent } from "./modules/components/routing/sub-route-function/sub-route-function.component";
import { SubRoutesComponent } from "./modules/components/routing/sub-routes/sub-routes.component";
import { OrderGenerateComponent } from "./modules/components/sales/order-generate/order-generate.component";
import { OrderListComponent } from "./modules/components/sales/order-list-components/order-list.component";
import { OrdersCreationComponent } from "./modules/components/sales/orders-creation/orders-creation.component";
import { QuotationGenerateComponent } from "./modules/components/sales/quotation-generate/quotation-generate.component";
import { QuotationComponent } from "./modules/components/sales/quotation/quotation.component";
import { SystemLatencyComponent } from "./modules/components/synchronization/system-latency/system-latency.component";
import { SystemServicesComponent } from "./modules/components/synchronization/system-services/system-services.component";
import { UserComponent } from "./modules/components/system/configuration/user/user.component";

import { AssetControlComponent } from "./modules/components/asset-c/asset-control/asset-control.component";
import { AssetGroupComponent } from "./modules/components/asset-c/asset-group/asset-group.component";
import { AssetComponent } from "./modules/components/asset-c/asset.component";
import { LoadsComponent } from "./modules/components/assistant/delivery/loads/loads.component";
import { SalesDistributionComponent } from "./modules/components/assistant/sales-distribution/sales-distribution.component";
import { OptimizationRoutesComponent } from "./modules/components/assistant/samantha/optimization-routes/optimization-routes.component";
import { SuggestedSalesComponent } from "./modules/components/assistant/samantha/suggested-sales/suggested-sales.component";
import { BusinessPartnerCreditComponent } from "./modules/components/business-partners/business-partner-credit/business-partner-credit.component";
import { DashboardComponent } from "./modules/components/dashboard/dashboard.component";
import { MobileComponent } from "./modules/components/dashboard/mobile/mobile.component";
import { ChangeConditionComponent } from "./modules/components/master/change-condition/change-condition.component";
import { RejectionTypeComponent } from "./modules/components/master/rejection-type/rejection-type.component";
import { MaterialGroupUnitMeasurementComponent } from "./modules/components/material/material-group-unit-measurement/material-group-unit-measurement.component";
import { MaterialListComponent } from "./modules/components/material/material-list/material-list.component";
import { PrincipalScreenComponent } from "./modules/components/monitor/principal-screen/principal-screen.component";
import { NGroupComponent } from "./modules/components/notification/n-group/n-group.component";
import { NMemberComponent } from "./modules/components/notification/n-member/n-member.component";
import { NNotificationComponent } from "./modules/components/notification/n-notification/n-notification.component";
import { NTemplateComponent } from "./modules/components/notification/n-template/n-template.component";
import { CreditApplicationComponent } from "./modules/components/reports/credit-application/credit-application.component";
import { CustomerRouteFrequencyComponent } from "./modules/components/reports/customer-route-frequency/customer-route-frequency.component";
import { CustomerTerritoriesComponent } from "./modules/components/reports/customer-territories/customer-territories.component";
import { ChargeInOutComponent } from "./modules/components/reports/historic/charge-in-out/charge-in-out.component";
import { DeliveryIncompleteHComponent } from "./modules/components/reports/historic/delivery-incomplete/delivery-incomplete.component";
import { DeliveryRejectionComponent } from "./modules/components/reports/historic/delivery-rejection/delivery-rejection.component";
import { DeliveryHComponent } from "./modules/components/reports/historic/delivery/delivery.component";
import { LossListHComponent } from "./modules/components/reports/historic/loss-list/loss-list.component";
import { OrderCustomerLogComponent } from "./modules/components/reports/historic/order-customer-log/order-customer-log.component";
import { OrderInvoiceComponent } from "./modules/components/reports/historic/order-invoice/order-invoice.component";
import { OrderSellerComponent } from "./modules/components/reports/historic/order-seller/order-seller.component";
import { ReturnProductRequestComponent } from "./modules/components/reports/historic/return-product-request/return-product-request.component";
import { ReturnProductComponent } from "./modules/components/reports/historic/return-product/return-product.component";
import { TotalNecessityComponent } from "./modules/components/reports/historic/total-neccessity/total-necessity.component";
import { LiquidationsComponent } from "./modules/components/reports/liquidations/liquidations.component";
import { LossReportComponent } from "./modules/components/reports/loss-report/loss-report.component";
import { RoutesTerritoriesComponent } from "./modules/components/reports/routes-territories/routes-territories.component";
import { VisitCheckComponent } from "./modules/components/reports/visits/visit-check/visit-check.component";
import { ChangeItemListComponent } from "./modules/components/sales/change-item-list/change-item-list.component";
import { DeliveryListComponent } from "./modules/components/sales/delivery-list/delivery-list.component";
import { GeolocationComponent } from "./modules/components/sales/geolocation-pending/geolocation-pending.component";
import { InvoiceListComponent } from "./modules/components/sales/invoice-list/invoice-list.component";
import { LoadDocumentListComponent } from "./modules/components/sales/load-document-list/load-document-list.component";
import { LossListComponent } from "./modules/components/sales/loss-list/loss-list.component";
import { RequestChangeItemComponent } from "./modules/components/sales/request-change-item/request-change-item.component";
import { RequestReturnListComponent } from "./modules/components/sales/request-return-list/request-return-list.component";
import { ReturnListComponent } from "./modules/components/sales/return-list/return-list.component";
import { SellerOrderComponent } from "./modules/components/sales/seller-order/seller-order.component";
import { TripComponent } from "./modules/components/sales/trip/trip.component";
import { DefaultkeysComponent } from "./modules/components/system/configuration/externalkeys/defaultkeys.component";
import { GroupComponent } from "./modules/components/system/configuration/group/group.component";
import { TypeVehicleComponent } from "./modules/components/transport/type-vehicle/type-vehicle.component";
import { VechicleComponent } from "./modules/components/transport/vechicle/vechicle.component";
import { FormatUploadComponent } from "./modules/components/uploadFormat/format-upload/format-upload.component";
import { MapModalComponent } from "./shared/components/map-modal/map-modal.component";
import { ExpenseReasonComponent } from "./modules/components/payment-master/expense-reason/expense-reason.component";
import { ExpenseListComponent } from "./modules/components/payment-master/expense/expense-list/expense-list.component";
import { ExpenseReportComponent } from "./modules/components/reports/historic/expense-report/expense-report.component";
import { SmartGridDemoComponent } from "./modules/components/demo/smart-grid-demo/smart-grid-demo.component";
import { HandlerMessageDemoComponent } from "./modules/components/demo/handler-message-demo/handler-message-demo.component";
import { DocumentClassLineComponent } from "./modules/components/document/document-class-line/document-class-line.component";
import { DocumentTypeLineComponent } from "./modules/components/document/document-type-line/document-type-line.component";
import { QuotaComponent } from "./modules/components/routing/sub-route-quota/sub-route-quota.component";
import { TemporaryPasswordsComponent } from "./modules/components/system/configuration/temporary-passwords/temporary-passwords.component";
import { VisitGpsComponent } from "./modules/components/reports/visits/visit-gps/visit-gps.component";
import { VisitTrackingReportComponent } from "./modules/components/reports/visits/visit-tracking/visit-tracking.component";

export const appRoutes: Route[] = [
  // Ruta para redirigir por defecto a 'home'
  {
    path: "",
    redirectTo: "home", // Redirigir a "home" por defecto
    pathMatch: "full",
  },

  // Rutas para usuarios no autenticados
  {
    path: "",
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "confirmation-required",
        loadChildren: () =>
          import(
            "app/modules/auth/confirmation-required/confirmation-required.routes"
          ),
      },
      // {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
      // {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
      {
        path: "sign-in",
        loadChildren: () => import("app/modules/auth/sign-in/sign-in.routes"),
      },
      {
        path: "sign-up",
        loadChildren: () => import("app/modules/auth/sign-up/sign-up.routes"),
      },
    ],
  },

  // Rutas para usuarios autenticados
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "sign-out",
        loadChildren: () => import("app/modules/auth/sign-out/sign-out.routes"),
      },
      {
        path: "unlock-session",
        loadChildren: () =>
          import("app/modules/auth/unlock-session/unlock-session.routes"),
      },
    ],
  },

  // Rutas de landing
  {
    path: "home",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "",
        component: HomeComponent,
        data: { breadcrumb: "Inicio" },
      }, // Página principal de home
    ],
  },

  // Development routes (only included in non-production environments)
  ...(!environment.production ? devRoutes : []),

  // Rutas para maestros
  {
    path: "master",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Maestros" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "locations",
        data: { breadcrumb: "Ubicacion" },

        children: [
          {
            path: "location-one",
            component: LocationOneComponent,
            data: { breadcrumb: "Países" },
          },
          {
            path: "location-two",
            component: LocationTwoComponent,
            data: { breadcrumb: "Departamentos" },
          },
          {
            path: "location-three",
            component: LocationThreeComponent,
            data: { breadcrumb: "Ciudades" },
          },
          {
            path: "location-four",
            component: LocationFourComponent,
            data: { breadcrumb: "Colonias" },
          },
          {
            path: "location-five",
            component: LocationFiveComponent,
            data: { breadcrumb: "Ubicación 5" },
          },
          {
            path: "location-six",
            component: LocationSixComponent,
            data: { breadcrumb: "Ubicación 6" },
          },
        ],
      },
      {
        path: "masters",
        data: { breadcrumb: "Maestros" },

        children: [
          {
            path: "bad-condition-motives",
            component: BadConditionMotiveComponent,
            data: { breadcrumb: "Motivos de Mal Estado" },
          },
          {
            path: "payment-conditions",
            component: PaymentConditionComponent,
            data: { breadcrumb: "Condiciones de Pago" },
          },
          {
            path: "payment-methods",
            component: PaymentMethodComponent,
            data: { breadcrumb: "Métodos de Pago" },
          },
          {
            path: "reasons-for-rejection",
            component: ReasonForRejectionComponent,
            data: { breadcrumb: "Motivos de Rechazo" },
          },
          {
            path: "price-list",
            component: PriceListComponent,
            data: { breadcrumb: "Listas" },
          },
          {
            path: "strategy-list",
            component: StrategyListComponent,
            data: { breadcrumb: "Cnf. Listas" },
          },
          {
            path: "reasons-for-visit",
            component: ReasonForVisitComponent,
            data: { breadcrumb: "Motivos de Visita" },
          },
          {
            path: "requirement",
            component: RequirementComponent,
            data: { breadcrumb: "Requisitos" },
          },
          {
            path: "rejection-type",
            component: RejectionTypeComponent,
            data: { breadcrumb: "Tipos de Rechazo" },
          },
          {
            path: "reasons-for-block",
            component: ReasonForBlockComponent,
            data: { breadcrumb: "Mtvo. de Bloqueo SN" },
          },
          {
            path: "group-units-of-measurement",
            component: MaterialGroupUnitMeasurementComponent,
            data: { breadcrumb: "Grupos de Unidades de Medida" },
          },
          {
            path: "units-of-measurement",
            component: UnitOfMeasurementComponent,
            data: { breadcrumb: "Unidades de Medida" },
          },
          {
            path: "expedition-condition",
            component: ExpeditionConditionComponent,
            data: { breadcrumb: "Condiciones de Expedición" },
          },
          {
            path: "change-condition",
            component: ChangeConditionComponent,
            data: { breadcrumb: "Condiciones de Cambio" },
          },
        ],
      },
      {
        path: "payment-masters",
        data: { breadcrumb: "Pagos" },
        children: [
          {
            path: "payment-types",
            component: PaymentTypeComponent,
            data: { breadcrumb: "Tipos de Pago" },
          },
          {
            path: "payment-methods",
            component: PaymentMethodComponent,
            data: { breadcrumb: "Métodos de Pago" },
          },
          {
            path: "banks",
            component: BankComponent,
            data: { breadcrumb: "Bancos" },
          },
          {
            path: "expense-reason",
            component: ExpenseReasonComponent,
            data: { breadcrumb: "Motivos de gastos" },
          },
        ],
      },
      {
        path: "sales",
        data: { breadcrumb: "Maestros" },
        children: [
          {
            path: "orders-list",
            component: OrderListComponent,
            data: { breadcrumb: "Listado de Pedidos" },
          },
          {
            path: "orders-creation",
            component: OrdersCreationComponent,
            data: { breadcrumb: "Creación old de Órdenes" },
          },
          {
            path: "order-generate",
            component: OrderGenerateComponent,
            data: { breadcrumb: "Generación de Pedidos" },
          },
          {
            path: "quotation-generate",
            component: QuotationGenerateComponent,
            data: { breadcrumb: "Generación de Cotización" },
          },
          {
            path: "quotation-list",
            component: QuotationComponent,
            data: { breadcrumb: "Listado de Cotizaciones" },
          },
          {
            path: "load-documents-list",
            component: LoadDocumentListComponent,
            data: { breadcrumb: "Listado de Documentos de carga" },
          },
          {
            path: "delivery-list",
            component: DeliveryListComponent,
            data: { breadcrumb: "Listado de Entregas" },
          },
          {
            path: "invoice-list",
            component: InvoiceListComponent,
            data: { breadcrumb: "Listado de Facturas" },
          },
          {
            path: "request-change-item-list",
            component: RequestChangeItemComponent,
            data: { breadcrumb: "Listado de Solicitud Cambio de Productos" },
          },
          {
            path: "change-item-list",
            component: ChangeItemListComponent,
            data: { breadcrumb: "Listado de Cambio de Productos" },
          },
          {
            path: "request-return-list",
            component: RequestReturnListComponent,
            data: {
              breadcrumb: "Listado de Solicitud Devolución de Productos",
            },
          },
          {
            path: "return-list",
            component: ReturnListComponent,
            data: { breadcrumb: "Listado de Devolución de Productos" },
          },
          {
            path: "loss-list",
            component: LossListComponent,
            data: { breadcrumb: "Lista de Mermas" },
          },
          {
            path: "trip",
            component: TripComponent,
            data: { breadcrumb: "Listado de Viajes" },
          },
          {
            path: "geolocation-pending",
            component: GeolocationComponent,
            data: { breadcrumb: "Geolocalización Pendiente" },
          },
        ],
      },
      {
        path: "request",
        data: { breadcrumb: "Solicitudes" },
        children: [
          {
            path: "seller-order",
            component: SellerOrderComponent,
            data: { breadcrumb: "Pedido Vendedor" },
          },
        ],
      },
      {
        path: "collections",
        data: { breadcrumb: "Cobranza" },
        children: [
          {
            path: "open-items",
            component: OpenPItemComponent,
            data: { breadcrumb: "Partidas Abiertas" },
          },
          {
            path: "payment-management",
            component: PaymentManagementComponent,
            data: { breadcrumb: "Pagos" },
          },
          {
            path: "expense-list",
            component: ExpenseListComponent,
            data: { breadcrumb: "Gastos" },
          },
        ],
      },
      {
        path: "business-partner",
        data: { breadcrumb: "Socios de Negocios" },
        children: [
          {
            path: "business-partner-news",
            component: BusinessPartnerNewsComponent,
            data: { breadcrumb: "Nuevos Clientes" },
          },
          {
            path: "business-partner",
            component: BusinessPartnerComponent,
            data: { breadcrumb: "Socios de Negocio" },
          },
          {
            path: "request-credit",
            component: BusinessPartnerCreditComponent,
            data: { breadcrumb: "Solicitud de crédito" },
          },
          {
            path: "business-partner-function",
            component: BusinessPartnerFunctionComponent,
            data: { breadcrumb: "Funciones de Interlocutor" },
          },
          {
            path: "business-partner-contact",
            component: BusinessPartnerContactComponent,
            data: { breadcrumb: "Funciones de Contacto" },
          },
          {
            path: "business-partner-type",
            component: BusinessPartnerTypeComponent,
            data: { breadcrumb: "Tipo de Socios de Negocio" },
          },
          {
            path: "business-partner-group",
            component: BusinessPartnerGroupComponent,
            data: { breadcrumb: "Grupo de Socios de Negocio" },
          },
          {
            path: "business-partner-subgroup",
            component: BusinessPartnerSubGroupComponent,
            data: { breadcrumb: "Subgrupo de Socios de Negocio" },
          },
          {
            path: "pending-addresses",
            component: BusinessPartnerAddressPendingSyncComponent,
            data: { breadcrumb: "Direcciones pendientes por aprobar" },
          },
          {
            path: "pending-addresses",
            component: BusinessPartnerAddressPendingSyncComponent,
            data: { breadcrumb: "Direcciones pendientes por aprobar" },
          },
        ],
      },
      {
        path: "materials",
        data: { breadcrumb: "Materiales" },
        children: [
          {
            path: "material-group",
            component: MaterialGroupComponent,
            data: { breadcrumb: "Grupos de Materiales" },
          },
          {
            path: "material-brand",
            component: MaterialBrandComponent,
            data: { breadcrumb: "Marcas" },
          },
          {
            path: "material",
            component: MaterialComponent,
            data: { breadcrumb: "Materiales" },
          },
          {
            path: "list-material",
            component: MaterialListComponent,
            data: { breadcrumb: "Lista de Materiales" },
          },
        ],
      },
      {
        path: "configuration",
        data: { breadcrumb: "Configuraciones" },
        children: [
          {
            path: "tenant",
            component: TenantComponent,
          },
          {
            path: "company",
            component: CompanyComponent,
            data: { breadcrumb: "Compañias" },
          },
          {
            path: "sales-organization",
            component: SalesOrganizationComponent,
            data: { breadcrumb: "Organización de Ventas" },
          },
          {
            path: "channel",
            component: ChannelComponent,
            data: { breadcrumb: "Canales de Distribución" },
          },
          {
            path: "division",
            component: DivisionComponent,
            data: { breadcrumb: "Divisiones" },
          },
          {
            path: "distribution-chain",
            component: DistributionChainComponent,
            data: { breadcrumb: "Cadenas de Distribución" },
          },
          {
            path: "office-group",
            component: OfficeGroupComponent,
            data: { breadcrumb: "Grupos de Oficinas de Venta" },
          },
          {
            path: "sales-office",
            component: SalesOfficeComponent,
            data: { breadcrumb: "Oficinas de Venta" },
          },
          {
            path: "plant",
            component: PlantComponent,
            data: { breadcrumb: "Plantas" },
          },
          {
            path: "warehouse",
            component: WarehouseComponent,
            data: { breadcrumb: "Almacenes" },
          },
        ],
      },
      {
        path: "common",
        data: { breadcrumb: "Comunes" },
        children: [
          {
            path: "social-media-type",
            component: SocialMediaTypeComponent,
            data: { breadcrumb: "Redes Sociales" },
          },
          {
            path: "address-type",
            component: AddressTypeComponent,
            data: { breadcrumb: "Tipos de Dirección" },
          },
          {
            path: "phone-type",
            component: PhoneTypeComponent,
            data: { breadcrumb: "Tipos de Teléfono" },
          },
        ],
      },
      {
        path: "routing",
        data: { breadcrumb: "routing" },
        children: [
          {
            path: "route",
            component: RouteComponent,
            data: { breadcrumb: "Territorios" },
          },
          {
            path: "sub-route",
            component: SubRoutesComponent,
            data: { breadcrumb: "Rutas" },
          },
          {
            path: "route-group",
            component: RouteGroupComponent,
            data: { breadcrumb: "Grupos de Rutas" },
          },
          {
            path: "route-area",
            component: RouteAreaComponent,
            data: { breadcrumb: "Áreas de Rutas" },
          },
          {
            path: "sub-route-function",
            component: SubRouteFunctionComponent,
            data: { breadcrumb: "Función de Rutas" },
          },
          {
            path: "sub-route-activity",
            component: SubRouteActivityComponent,
            data: { breadcrumb: "Actividades de Rutas" },
          },
          {
            path: "customer-route-frequency-report",
            component: CustomerRouteFrequencyComponent,
            data: { breadcrumb: "Cliente y frecuencia de rutas" },
          },
          {
            path: "customer-territories-report",
            component: CustomerTerritoriesComponent,
            data: { breadcrumb: "Clientes y territorios" },
          },
          {
            path: "routes-territories-report",
            component: RoutesTerritoriesComponent,
            data: { breadcrumb: "Rutas de territorios" },
          },
          {
            path: "liquidation-report",
            component: LiquidationsComponent,
            data: { breadcrumb: "Liquidaciones" },
          },
          {
            path: "",
            component: LiquidationsComponent,
            data: { breadcrumb: "Liquidaciones" },
          },
          {
            path: "loss-report",
            component: LossReportComponent,
            data: { breadcrumb: "Mermas" },
          },
          {
            path: "sub-route-quota",
            component: QuotaComponent,
            data: { breadcrumb: "Cuotas" },
          },
        ],
      },
      // {

      //     path:'reasons',
      //     data:{breadcrumb:'reasons'},
      //     children:[
      //         {
      //             path: 'rejection-type',
      //             component: RejectionTypeComponent,
      //             data: { breadcrumb: 'Tipos de Rechazo' },
      //         }
      //     ],
      // },
      {
        path: "document",
        data: { breadcrumb: "document" },
        children: [
          {
            path: "document-type",
            component: DocumentTypeComponent,
            data: { breadcrumb: "Tipos de Documento" },
          },
          {
            path: "document-type-line",
            component: DocumentTypeLineComponent,
            data: { breadcrumb: "Tipos de Línea" },
          },
          {
            path: "document-class",
            component: DocumentClassComponent,
            data: { breadcrumb: "Clases de Documento" },
          },
          {
            path: "emission-point",
            component: EmissionPointComponent,
            data: { breadcrumb: "Punto de Emisión" },
          },
          {
            path: "document-range",
            component: DocumentRangeComponent,
            data: { breadcrumb: "Rango de Documentos" },
          },
          {
            path: "document-class-line",
            component: DocumentClassLineComponent,
            data: { breadcrumb: "Clases de Línea" },
          },
        ],
      },
      {
        path: "transport",
        data: { breadcrumb: "Transporte" },
        children: [
          {
            path: "transport-type",
            component: TypeVehicleComponent,
            data: { breadcrumb: "Tipos de Vehículos" },
          },
          {
            path: "transport-vehicle",
            component: VechicleComponent,
            data: { breadcrumb: "Vehículos" },
          },
        ],
      },
    ],
  },

  // Rutas para Asistente

  {
    path: "assistant",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Asistente" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "sales",
        data: { breadcrumb: "Ventas" },
        children: [
          {
            path: "distribution",
            data: { breadcrumb: "Asistente de Distribución" },
            component: SalesDistributionComponent,
          },
        ],
      },
      {
        path: "delivery",
        data: { breadcrumb: "Entrega" },
        children: [
          {
            path: "loads",
            data: { breadcrumb: "Asignación de Carga" },
            component: LoadsComponent,
          },
        ],
      },
      {
        path: "sales",
        data: { breadcrumb: "Samantha" },
        children: [
          {
            path: "suggested-sales",
            data: { breadcrumb: "Predicción de Ventas" },
            component: SuggestedSalesComponent,
          },
          {
            path: "optimization-routes",
            data: { breadcrumb: "Optimización de Rutas" },
            component: OptimizationRoutesComponent,
          },
        ],
      },
    ],
  },

  //Rutas para reportes
  {
    path: "reports",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Reportes" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "stock-break",
        data: { breadcrumb: "Quiebre de Inventario" },
        component: StockBreakComponent,
      },
      {
        path: "credit-application",
        component: CreditApplicationComponent,
        data: { breadcrumb: "Solicitudes de Crédito" },
      },
      {
        path: "lost-sale",
        data: { breadcrumb: "Venta Perdida" },
        component: LostSaleComponent,
      },
      {
        path: "lost-sale-v2",
        component: LostSaleV2Component,
        data: { breadcrumb: "Venta Perdida" },
        children: [
          {
            path: "",
            redirectTo: "commercial",
            pathMatch: "full",
          },
          {
            path: "commercial",
            component: LostSaleCommercialComponent,
            data: { breadcrumb: "Comercial" },
          },
          {
            path: "summary",
            component: LostSaleSummaryComponent,
            data: { breadcrumb: "Resumen" },
          },
        ],
      },
      {
        path: "visits",
        data: { breadcrumb: "Visitas" },
        children: [
          {
            path: "visit-control",
            component: VisitControlComponent,
            data: { breadcrumb: "Control de Visitas" },
          },
          {
            path: "visit-report",
            component: VisitReportComponent,
            data: { breadcrumb: "Reporte de Visitas" },
          },
          {
            path: "visit-check",
            component: VisitGpsComponent, // VisitCheckComponent,
            data: { breadcrumb: "Check In/Out" },
          },
          {
            path: "visit-tracking",
            component: VisitTrackingReportComponent,
            data: { breadcrumb: "Seguimiento de Visita"}
          },
          {
            path: "census-quality",
            component: CensusQualityComponent,
            data: { breadcrumb: "Calidad de Censos" },
          },
        ],
      },
      {
        path: "historic",
        data: { breadcrumb: "Históricos" },
        children: [
          {
            path: "change-product",
            component: ChangeProductComponent,
            data: { breadcrumb: "Cambios de Productos" },
          },
          {
            path: "return-product",
            component: ReturnProductComponent,
            data: { breadcrumb: "Devoluciones de Productos" },
          },
          {
            path: "return-product-request",
            component: ReturnProductRequestComponent,
            data: { breadcrumb: "Devoluciones de Productos" },
          },
          {
            path: "order-customer",
            component: OrderCustomerComponent,
            data: { breadcrumb: "Pedidos de Clientes" },
          },
          {
            path: "order-customer-log",
            component: OrderCustomerLogComponent,
            data: { breadcrumb: "Pedidos Modificados de Clientes" },
          },
          {
            path: "order-seller",
            component: OrderSellerComponent,
            data: { breadcrumb: "Pedidos de Vendedor" },
          },
          {
            path: "order-invoice",
            component: OrderInvoiceComponent,
            data: { breadcrumb: "Facturas de Clientes" },
          },
          {
            path: "attention-stock",
            component: AttentionStockComponent,
            data: { breadcrumb: "Stock" },
          },
          {
            path: "open-items",
            component: OpenItemComponent,
            data: { breadcrumb: "Partidas Abiertas" },
          },
          {
            path: "proration",
            component: ProrationComponent,
            data: { breadcrumb: "Prorrateo" },
          },
          {
            path: "order-payment",
            component: OrderPaymentComponent,
            data: { breadcrumb: "Cobranza" },
          },
          {
            path: "request-change",
            data: { breadcrumb: "Solicitud de Cambio" },
            component: RequestChangeComponent,
          },
          {
            path: "total-necessity",
            component: TotalNecessityComponent,
            data: { breadcrumb: "Necesidad Total" },
          },
          {
            path: "delivery-incomplete",
            component: DeliveryIncompleteHComponent,
            data: { breadcrumb: "Entregas Incompletas" },
          },
          {
            path: "delivery-rejection",
            component: DeliveryRejectionComponent,
            data: { breadcrumb: "Entregas Rechazadas" },
          },
          {
            path: "charge-in-out",
            component: ChargeInOutComponent,
            data: { breadcrumb: "Carga In/Out" },
          },
          {
            path: "delivery",
            component: DeliveryHComponent,
            data: { breadcrumb: "Entregas" },
          },
          {
            path: "loss-list",
            component: LossListHComponent,
            data: { breadcrumb: "Merma" },
          },
          {
            path: "expense-report",
            component: ExpenseReportComponent,
            data: { breadcrumb: "Gastos" },
          },
        ],
      },
      {
        path: "modify",
        data: { breadcrumb: "Modificaciones" },
        children: [
          {
            path: "order-customer-log",
            component: OrderCustomerLogComponent,
            data: { breadcrumb: "Pedidos Modificados de Clientes" },
          },
        ],
      },
    ],
  },

  //Rutas para Monitoreo
  {
    path: "monitor",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Monitor" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "principal-screen",
        component: PrincipalScreenComponent,
        data: { breadcrumb: "Monitor" },
      },
    ],
  },

  //Dashboard
  {
    path: "dashboard",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Dashboard" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "principal",
        component: DashboardComponent,
        data: { breadcrumb: "Dashboard" },
      },
      {
        path: "mobile",
        component: MobileComponent,
      },
    ],
  },

  //Rutas para Formato de Carga
  {
    path: "uploadFormat",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Formatos de Carga" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "format-upload",
        component: FormatUploadComponent,
        data: { breadcrumb: "Formatos de Carga" },
      },
    ],
  },

  // Sincronización
  {
    path: "synchronization",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Sincronización" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "system-services",
        component: SystemServicesComponent,
        data: { breadcrumb: "Servicios de sincronización" },
      },
      {
        path: "system-latency",
        component: SystemLatencyComponent,
        data: { breadcrumb: "Latencia" },
      },
    ],
  },

  //Notificaciones
  {
    path: "notification",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Notificación" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "notification-member",
        component: NMemberComponent,
        data: { breadcrumb: "Miembros de notificación" },
      },
      {
        path: "notification-group",
        component: NGroupComponent,
        data: { breadcrumb: "Grupos de notificación" },
      },
      {
        path: "notification",
        component: NNotificationComponent,
        data: { breadcrumb: "Lista de notificación" },
      },
      {
        path: "templates",
        component: NTemplateComponent,
        data: { breadcrumb: "Templates" },
      },
    ],
  },

  //Activos
  {
    path: "asset",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Activos" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "asset",
        component: AssetComponent,
        data: { breadcrumb: "Activo" },
      },
      {
        path: "asset-group",
        component: AssetGroupComponent,
        data: { breadcrumb: "Grupos de Activos" },
      },
      {
        path: "asset-control",
        component: AssetControlComponent,
        data: { breadcrumb: "Control de Activos" },
      },
    ],
  },

  // Rutas de system
  {
    path: "configurations",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "users",
        component: UserComponent,
        data: { breadcrumb: "Usuarios" },
      },
      {
        path: "groups",
        component: GroupComponent,
        data: { breadcrumb: "Grupos" },
      },
      {
        path: "external-keys",
        component: DefaultkeysComponent,
        data: { breadcrumb: "Default Keys" },
      },
      {
        path: "temporary-passwords",
        component: TemporaryPasswordsComponent,
        data: { breadcrumb: "Contraseñas Temporales" },
      },
    ],
  },

  {
    path: "menu-management",
    canActivate: [AuthGuard, RoutePermissionGuard],
    canActivateChild: [AuthGuard, RoutePermissionGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Gestión de Menús" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/admin/menu-management/menu-management.routes"),
      },
    ],
  },
  // Demo Components
  {
    path: "demo",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: { breadcrumb: "Demo" },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "smart-grid",
        component: SmartGridDemoComponent,
        data: { breadcrumb: "Smart Grid" },
      },
    ],
  },

  // Preview - Handler Message Service Demo
  {
    path: "preview",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: { 
      layout: "empty",
      breadcrumb: "Preview" 
    },
    children: [
      {
        path: "handler-message",
        component: HandlerMessageDemoComponent,
        data: { breadcrumb: "Handler Message Service" },
      },
    ],
  },

  //Other
  {
    path: "geo-viewer",
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    data: {
      breadcrumb: "Visor Geográfico",
      title: "Visor Geográfico",
      layout: "empty",
    },
    children: [
      {
        path: "",
        component: MapModalComponent,
        data: { breadcrumb: "Visor Geográfico" },
      },
    ],
  },
];
